const data = {
  "searchField": {
    "placeholder": "Zoeken naar...",
    "ariaLabel": "Zoeken naar producten",
    "buttonAriaLabel": "Zoeken",
    "cancelButtonText": "Annuleren"
  }
};

export default data;